import { render, staticRenderFns } from "./FixRequest.vue?vue&type=template&id=b84b0560"
import script from "./FixRequest.vue?vue&type=script&lang=js"
export * from "./FixRequest.vue?vue&type=script&lang=js"
import style0 from "./FixRequest.vue?vue&type=style&index=0&id=b84b0560&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports